import { Route } from '@angular/router'
import { appCommonRoutes } from './app.routes.common'

export const appRoutes: Route[] = [...appCommonRoutes]
